import type { FaireProductEntity } from "../../entity_types/product";

export const p_7j4zkbp3zt: FaireProductEntity = {
  token: "p_7j4zkbp3zt",
  type: "product",
  name: "Custom  Youth Sweatshirt /Custom Text Varsity",
  brandToken: "b_n9fwmzzqs5",
  brandName: "One Nine",
  imageUrl:
    "https://cdn.faire.com/fastly/8c35e6ab1761c0fec14a05f46e623fe80ef28fd23c12691d75d8eb1e0b660c8a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/708dcfde9481bccc0af97781085d87cff6f678e4eaa678a167309f2ca50c7ff8.jpeg",
    "https://cdn.faire.com/fastly/b637127e3f0f1be4e319e4d2ad570a9ff2b622aacaf93e0e34db9ba547cfbfa9.jpeg",
  ],
  priceDollars: 18.95,
  description:
    "Custom Sweatshirt, Customizable Products\n\n👍Personalize these ultra comfy tees with your logo, artwork or words in any single print \n     location\n\n✌️If you have artwork, message us your image file before purchase to be sure we can get a good \n     print from it. We can print multi color designs!\n\n  👍We will send you a proof/mockup to approve, and make any adjustments, before printing. \n\n👌Keep in mind that we will not print anything copyrighted or trademarked. \n\n\n\n👕 Unmatched Softness: Dive into a world of unparalleled comfort with our supremely soft fabric. Each touch is a gentle embrace, ensuring you feel relaxed all day long.\n",
  tags: [],
  msrpDollars: 37.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:09.963Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
